import {UIDatePickerAdapter} from './date-picker.adapter';
import { Injectable } from "@angular/core";

@Injectable()
export class UIDatePickerAdapterNumber extends UIDatePickerAdapter<number> {
  fromMilliseconds(milliseconds: number): number {
    return milliseconds;
  }
  toMilliseconds(value: number | null): number | null {
    return value;
  }
}
